// libraries
import React from 'react'
import clsx from 'clsx'

// components
import Image from '/react4xp/components/Image'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

export interface ArticleCardNewProps {
	featured: boolean
	href: {
		url: string
		isExternal?: boolean
	}
	img?: {
		src?: string
		srcSmall?: string
		alt?: string
	}
	category?: 'insights' | 'news'
	customCategory?: Array<string>
	title: string
}

export default function ArticleCardNew({
   featured,
   href,
   img,
   category,
   customCategory,
   title
}: ArticleCardNewProps) {
	return (
		featured ? (
			<a
				href={href?.url}
				target={href?.isExternal ? '_blank' : undefined}
				className={clsx(
					'article-card-new-featured',
					!img?.src && 'article-card-new-featured--no-image'
				)}
			>
				<div className='grid-row'>

					<div className='c-md-8 article-card-new-featured__left'>
						<div className='article-card-new-featured__left__image'>
							{img?.src && (
								<Image
									srcSmall={[`${img.srcSmall}`, 574]} // 450x450
									src={img.src} // 900x500
									alt={img.alt}
									className='cover'
								/>
							)}
						</div>
					</div>

					<div className='c-md-4 article-card-new-featured__right'>
						<div className='article-card-new-featured__content'>

							<div className='article-card-new-featured__badges'>
								
								{ category && category === 'insights' && <Badge category='insights' text='Insights' /> }
								{ category && category === 'news' && <Badge category='news' text='News' /> }

								{customCategory && customCategory.length === 1 && (
									customCategory && customCategory.slice(0, 1).map((item, i) => (
										<Badge
											key={i}
											category='other'
											text={item}
										/>
									))
								)}

							</div>

							{isNonWhitespaceString(title) && (
								<h3 className='article-card-new-featured__title'>
									{title}
								</h3>	
							)}

						</div>
					</div>

				</div>
			</a>
		) : (
			<a
				href={href?.url}
				target={href?.isExternal ? '_blank' : undefined}
				className={clsx(
					'article-card-new',
					!img?.src && 'article-card-new--no-image'
				)}
			>
				<div className='article-card-new__image'>
					{img?.src && (
						<Image
							src={img.src} // 450x300
							alt={img.alt}
							className='cover'
						/>
					)}
				</div>

				<div className='article-card-new__content'>

					<div className='article-card-new__badges'>
						
						{ category && category === 'insights' && <Badge category='insights' text='Insights' /> }
						{ category && category === 'news' && <Badge category='news' text='News' /> }

						{customCategory && customCategory.length === 1 && (
							customCategory && customCategory.slice(0, 1).map((item, i) => (
								<Badge
									key={i}
									category='other'
									text={item}
								/>
							))
						)}

					</div>

					{isNonWhitespaceString(title) && (
						<h3 className='article-card-new__title'>
							{title}
						</h3>	
					)}

				</div>

			</a>
		)
	)
}

interface BadgeProps {
	category: 'insights' | 'news' | 'other'
	text: string
}

export function Badge({
	category,
	text
}: BadgeProps) {
	return (
		<div className={clsx(
			category === 'insights' && 'badge-new badge-new--insights',
			category === 'news' && 'badge-new badge-new--news',
			category === 'other' && 'badge-new badge-new--other'
		)}>
			{text}
		</div>
	)
}